export interface Team {
  id: string;
  name: string;
  code: string;
  flag: string;
  pot: number;
  group: string;
  confederation: string;
}

export interface Venue {
  id: string;
  name: string;
  city: string;
  country: string;
  capacity: number;
}

export interface GroupMatch {
  id: string;
  matchNumber: number;
  date: string;
  time: string;
  venueId: string;
  group: string;
  team1Id: string;
  team2Id: string;
  team1Score?: number;
  team2Score?: number;
}

export interface KnockoutMatch {
  id: string;
  matchNumber: number;
  date: string;
  time: string;
  venueId: string;
  round: 'R32' | 'R16' | 'QF' | 'SF' | '3RD' | 'F';
  team1Source: string; // e.g., "1A" (winner of group A), "W73" (winner of match 73), "3ABCD" (best 3rd from groups A,B,C,D)
  team2Source: string;
  team1Id?: string; // Resolved team after group stage predictions
  team2Id?: string;
  team1Score?: number;
  team2Score?: number;
  winnerId?: string;
}

export interface GroupStanding {
  teamId: string;
  played: number;
  won: number;
  drawn: number;
  lost: number;
  goalsFor: number;
  goalsAgainst: number;
  goalDifference: number;
  points: number;
  position: number;
}

export interface Group {
  id: string;
  name: string;
  teams: string[]; // team IDs
  matches: string[]; // match IDs
  standings: GroupStanding[];
}

export interface TournamentData {
  teams: Team[];
  venues: Venue[];
  groups: Group[];
  groupMatches: GroupMatch[];
  knockoutMatches: KnockoutMatch[];
}

export interface Prediction {
  matchId: string;
  winnerId: string;
}

export interface GroupPrediction {
  groupId: string;
  standings: string[]; // Ordered team IDs from 1st to 4th
}

export interface UserPredictions {
  groupPredictions: GroupPrediction[];
  knockoutPredictions: Prediction[];
}

export type Round = 'GROUP' | 'R32' | 'R16' | 'QF' | 'SF' | '3RD' | 'F';

export const ROUND_NAMES: Record<Round, string> = {
  GROUP: 'Group Stage',
  R32: 'Round of 32',
  R16: 'Round of 16',
  QF: 'Quarter-finals',
  SF: 'Semi-finals',
  '3RD': 'Third Place',
  F: 'Final'
};

export const GROUPS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'] as const;
export type GroupLetter = typeof GROUPS[number];
